import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const setAuthToken = (token) => {
  if (token) client.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete client.defaults.headers.common["Authorization"];
};

export const getVoterId = () => {
  let v = localStorage.getItem("dz_voter");
  if (!v) {
    v = "anon-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("dz_voter", v);
  }
  return v;
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Etwas ist schiefgelaufen. Bitte erneut versuchen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// ---- Auth ----
export const apiRegister = (p) => client.post("/auth/register", p).then((r) => r.data);
export const apiLogin = (p) => client.post("/auth/login", p).then((r) => r.data);
export const apiMe = () => client.get("/auth/me").then((r) => r.data);

// ---- Public ----
export const fetchPublicDeals = (params) => client.get("/public/deals", { params }).then((r) => r.data);
export const fetchPublicDeal = (id) => client.get(`/public/deals/${id}`).then((r) => r.data);
export const fetchPublicCategories = () => client.get("/public/categories").then((r) => r.data);
export const voteDeal = (id, value) => client.post(`/public/deals/${id}/vote`, { value, voter_id: getVoterId() }).then((r) => r.data);
export const fetchMyVote = (id) => client.get(`/public/deals/${id}/my-vote`, { params: { voter_id: getVoterId() } }).then((r) => r.data);
export const fetchComments = (id) => client.get(`/public/deals/${id}/comments`).then((r) => r.data);
export const addComment = (id, text) => client.post(`/public/deals/${id}/comments`, { text }).then((r) => r.data);
export const submitDeal = (p) => client.post("/public/submit-deal", p).then((r) => r.data);
export const fetchMyDeals = () => client.get("/public/my-deals").then((r) => r.data);

// ---- Admin ----
export const fetchDeals = (params) => client.get("/deals", { params }).then((r) => r.data);
export const fetchDeal = (id) => client.get(`/deals/${id}`).then((r) => r.data);
export const createDeal = (p) => client.post("/deals", p).then((r) => r.data);
export const updateDeal = (id, p) => client.patch(`/deals/${id}`, p).then((r) => r.data);
export const deleteDeal = (id) => client.delete(`/deals/${id}`).then((r) => r.data);
export const scoreDeal = (id) => client.post(`/deals/${id}/score`).then((r) => r.data);
export const scoreAll = () => client.post(`/deals/score-all`).then((r) => r.data);
export const generateContent = (id, p) => client.post(`/deals/${id}/generate-content`, p).then((r) => r.data);
export const findNiches = (p) => client.post(`/niche/find`, p).then((r) => r.data);
export const fetchCategories = () => client.get("/categories").then((r) => r.data);
export const fetchStats = () => client.get("/stats").then((r) => r.data);
export const fetchSubmissions = () => client.get("/admin/submissions").then((r) => r.data);

// ---- Analytics ----
export const trackClick = (dealId) => client.post(`/public/deals/${dealId}/click`).catch(() => {});
export const trackPageview = (path) => client.post("/public/pageview", { path, referrer: document.referrer }).catch(() => {});
export const fetchAnalytics = () => client.get("/analytics").then((r) => r.data);

export default client;
